import { render, staticRenderFns } from "./showOut.vue?vue&type=template&id=5fc71bea&scoped=true&"
import script from "./showOut.vue?vue&type=script&lang=js&"
export * from "./showOut.vue?vue&type=script&lang=js&"
import style0 from "./showOut.vue?vue&type=style&index=0&id=5fc71bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc71bea",
  null
  
)

export default component.exports